const FORM_EVENT_SAVE_FIELD = 'saveField'
const FORM_EVENT_ADD_COLLECTION_ITEM = 'addCollectionItem'
const FORM_EVENT_REMOVE_COLLECTION_ITEM = 'removeCollectionItem'
export {FORM_EVENT_ADD_COLLECTION_ITEM, FORM_EVENT_REMOVE_COLLECTION_ITEM, FORM_EVENT_SAVE_FIELD}
